import { module } from 'modujs';
//import Clipboard from 'clipboard'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                share: 'share',
                close: 'hide'
            }
        }
    }

    init() {
        this.inner = this.$('inner')[0]

        //this.setupClipboard()
    }

    show() {
        document.documentElement.classList.add('has-modal-share-opened')
        //this.copylink.setAttribute('data-clipboard-text', window.location.href)
        this.inner.focus()
    }

    hide() {
        document.documentElement.classList.remove('has-modal-share-opened')
    }

    // setupClipboard() {
    //     this.copylink = this.$('copylink')[0]

    //     this.clipboard = new Clipboard(this.copylink);
    //     this.clipboard.on('error', function(e) {
    //         console.error('Action:', e.action);
    //         console.error('Trigger:', e.trigger);
    //     });
    //     this.clipboard.on('success', () => {
    //         alert(this.getData('text', this.copylink))
    //     });
    // }

    share(e) {
        const el = e.curTarget;
        const platform = this.getData('platform', e.curTarget)
        const url = window.location.href
        let shareUrl;

        switch(platform) {
            case 'facebook':
                console.log('facebook')
                shareUrl = 'https://facebook.com/sharer/sharer.php?u=' + url;
                this.openWindow(shareUrl);
                break;

            case 'twitter':
                shareUrl = 'https://twitter.com/share?url=' + url
                         + '&amp;text=' + encodeURIComponent(this.getData('text', e.curTarget))
                this.openWindow(shareUrl);
                break;

            case 'mail':
                const subject = encodeURIComponent(this.getData('subject', e.curTarget))
                const body = encodeURIComponent(this.getData('body', e.curTarget))
                this.openMail(subject, body);
                break;

            // case 'copylink':
            //     el.setAttribute('data-clipboard-text', url)
            //     console.log('copylink', el.getAttribute('data-clipboard-text'));


            //     break;
        }
    }

    openWindow(url) {
        window.open(url, 'Share', 'menubar=no, toolbar=no, resizable=yes, scrollbars=yes, height=500, width=600');
    }

    openMail(subject, body) {
        window.location = 'mailto:?subject=' + subject + '&body=' + body;
    }

    destroy() {
        //this.clipboard.destroy()
    }
}
